module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Enter some tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "data": _vm.filteredTags,
      "autocomplete": "",
      "field": "user.first_name",
      "icon": "label",
      "placeholder": "Add a tag"
    },
    on: {
      "typing": _vm.getFilteredTags
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.id))]), _vm._v(": " + _vm._s(props.option.user.first_name) + "\n                ")]
      }
    }]),
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n                    There are no items\n                ")])], 2)], 1), _vm._v(" "), _c('pre', {
    staticStyle: {
      "max-height": "400px"
    }
  }, [_c('b', [_vm._v("Tags:")]), _vm._v(_vm._s(_vm.tags))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d827994"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/taginput/examples/ExTemplatedAutocomplete.vue
// module id = 1255
// module chunks = 7 55